import { Observable } from 'rxjs';

import { IUserSettingsState } from '../store/state';

export abstract class UserSettingsFacadeProvider {
	selectUserSettings$: Observable<IUserSettingsState>;
	abstract updateUserSettings(settings: Partial<IUserSettingsState>): void;
	abstract loadUserSettings(): void;
}
